<template>
<div class="large-container">
	<div>
		<!--  -->
		<a href="javascript:;"   @click="handelDown">下载模板</a>
		<UploadFile 
			@on-success="getData"
			:btn-text="uploadBtnText"
			:data="params"
			url="/pc/guarantee/importCompanyUser"
			class="uploadBtn" 
		/>
	</div>
	<div class="mt15">
        <Table :columns="columns" :data="tableData" border >
            <template slot-scope="{ row, index }" slot="msg">
                <span :style="{color:row.success?'#333':'red'}">{{row.success?'校验通过':row.msg}}</span>
            </template>
        </Table>
	</div>
	<div class="center mt20">
		<Button @click="back">返回</Button>
		<Button type="primary" :disabled="!enable" @click="toUpload" :loading="loading">确认上传</Button>
	</div>
	<Modal
		v-model="modalDate"
		title="下载模板">
		<Form :label-width="130" ref="formValidate" :model="formYear" :rules="ruleValidate">
			<FormItem label="请选择投保年份" prop="year">
				<DatePicker type="year"   :options="disabledYear"  style="width: 200px" :value="formYear.year"   @on-change="dateChange"></DatePicker>
			</FormItem>
		</Form>
		<div slot="footer">
			<Button type="default" @click="modalDate=false">取消</Button>
			<Button type="primary" @click="confirmDown('formValidate')" :loading="modalLoading">确定</Button>
		</div>
	</Modal>
</div>
</template>
<script>
import UploadFile from '@/pages/haierProduct/components/common/UploadFile'
export default {
	components: { UploadFile },
	data () {
		return {
            tableData:[],
			pass:false,
			params:{
				productCode:'JIN_KONG',
				importType:this.$route.params.type,
				companyId:this.$route.params.id,
				deptId:this.$route.query.deptId,
			},
			loading:false,
			modalDate:false,
			modalLoading:false,
			formYear:{
				year:''
			},
			ruleValidate:{
				year: [
                    { required: true,  message: '请选择日期', trigger: 'change' }
                ]
			},
			disabledYear:{
				disabledDate (date) {
					const disabledDay = date.getFullYear()
					return disabledDay !=2025&&disabledDay !=2026;
                }
			}
		}
	},
	computed:{
		enable () {
			for(let i=0;i<this.tableData.length;i++){
				if(!this.tableData[i].success){
					return false
				}
			}
			return this.tableData.length>0
		},
		uploadBtnText(){
			const textMap={
				INIT:'年度首批投保导入',
				ADD:'批量增人导入',
				QUIT:'导入',
			}
			return textMap[this.params.importType]
		},
		columns(){
			if(this.params.importType=='INIT'||this.params.importType=='ADD'){
				return [
					{title: '校验结果',slot: 'msg',minWidth:220},
					{title: '员工号',key: 'empNo',width:120},
					{title: '*手机号',key: 'phone',width:130},
					{title: '*姓名',key: 'name',width:110},
					{title: '*性别',key: 'genderName',width:80},
					{title: '*证件类型',key: 'idTypeName',width:120},
					{title: '*证件号码',key: 'idNumber',minWidth:190},
					{title: '*出生日期',key: 'birthday',width:120},
					{title: '*国籍',key: 'nationality',width:120},
					{title: '*国家/地区',key: 'nationalityArea',width:120},
					{title: '*医保',key: 'hasSocialSecurityShow',width:80},
					{title: '*医保所在城市',key: 'socialSecurityCity',width:130},
					{title: '*职业',key: 'jobType',width:120},
					{title: '*入职日期',key: 'entryDate',width:120},
					{title: '*起保日期',key: 'effectiveDateStart',width:180},
					{title: '*终保日期',key: 'effectiveDateEnd',width:180},
					{title: '*保障方案',key: 'insurancePlan',width:120},
					{title: '保费（元）',key: 'premiumAmount',width:110},
				]
			}else{
				return [
					{title: '校验结果',slot: 'msg',minWidth:220},
					{title: '员工号',key: 'empNo',width:120},
					{title: '姓名',key: 'name',width:110},
					{title: '证件类型',key: 'idTypeName',width:95},
					{title: '证件号码',key: 'idNumber',minWidth:190},
					{title: '出生日期',key: 'birthday',width:120},
					{title: '起保日期',key: 'effectiveDateStart',width:180},
					{title: '终保日期',key: 'effectiveDateEnd',width:180},
					{title: '保费（元）',key: 'premiumAmount',width:110},
				]
			}
		},
	},
	methods:{
		/*获取上传数据*/
		getData (res) {
			this.tableData = res.data;
		},
		/*去上传*/
		toUpload () {
			this.loading=true
			this.$axios.post('/guarantee/doImportCompanyUser.json',{
				...this.params,
				list:this.tableData
			}).then(res=>{
				this.toast('提交成功')
				setTimeout(()=>{
					this.back()
				},2000)
			}).catch(res=>{
				this.loading=false
			})
		},
		handelDown(){
			this.modalDate=true
		},
		dateChange(date){
			this.formYear.year = date
		},
		confirmDown(name){
			this.$refs[name].validate((valid) =>{
				if(valid){
					this.modalLoading=true
					const url = `/pc/guarantee/downloadCompanyUserTemplate?importType=${this.params.importType}&productCode=${this.params.productCode}&year=${this.formYear.year}`
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', '')   
					document.body.appendChild(link) 
					link.click() 
					document.body.removeChild(link)
					this.modalDate=false
					this.modalLoading=false
				}
			})	
		},
		back(){
            this.$router.back()
        }
	}
}
</script>
<style scoped lang="less">
.uploadBtn{
    display: inline-block;
    margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/jinkong/detail/ImportPerson.vue